module.exports = __webpack_public_path__ + "static/paris-4e76e3ad5e1e08868e602f91ba465ca2.jpg";